import { CogniteClient } from '@cognite/sdk';

const sdk = new CogniteClient({
  appId: 'Data Studio',
});

export { sdk };
